export class ProjectFilter {
    constructor(container, itemsPerPage) {
        this.container = container;
        this.itemsPerPage = itemsPerPage;
        this.currentPage = 1;
        this.totalPages = 1;
        this.activeFilters = [];
    }

    init() {
        if (!this.container) return; // Check if the container element exists on the page

        this.attachEventListeners();
        this.attachFilterEventListeners();
    }

    attachEventListeners() {
        const pagination = document.querySelector('.pagination');
        if (!pagination) return; // Check if the pagination element exists on the page

        pagination.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.target;

            if (target.classList.contains('pagination__page-link') && !target.hasAttribute('disabled')) {
                const targetPage = parseInt(target.dataset.page);
                this.fetchPage(targetPage);
            }
        });
    }

    attachFilterEventListeners() {

        const sectorCheckboxes = document.querySelectorAll(".sector-item input[type='checkbox']");
        sectorCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => this.filterProjects());
        });
    }

    filterProjects() {
        this.activeFilters = Array.from(document.querySelectorAll(".sector-item input[type='checkbox']:checked")).map(
            (checkbox) => checkbox.value
        );
        this.fetchPage(1);
    }


    fetchPage(page) {
        const url = omgwpAjax.ajax_url;
        const data = new FormData();
        data.append("action", "handle_project_filter_pagination");
        data.append("sectors", JSON.stringify(this.activeFilters));
        data.append("nonce", omgwpAjax.nonce);
        data.append("page", page);
        data.append("per_page", this.itemsPerPage);
        fetch(url, {method: "POST", body: data})
            .then((response) => response.json())
            .then((r) => {
                this.currentPage = page;
                this.updateProjects(r.data.projects);
                this.updatePagination(r.data.total_pages);
            })
            .catch((error) => {
                console.error('Error fetching page:', error);
            });
    }

    updateProjects(projects) {
        document.querySelector('.projects__list').innerHTML = '';

        projects.forEach((project) => {
            const item = `
     <div class="projects__item">
        <a href="${project.permalink}">
          ${project.thumbnail}
          <h3 class="projects__title">${project.title}</h3>
        </a>
      </div>
      `;

            document.querySelector('.projects__list').innerHTML += item;
        });
    }

    updatePagination(totalPages) {
        this.totalPages = totalPages;
        const pagination = document.querySelector('.pagination');
        if (!pagination) return; // Check if the pagination element exists on the page
        pagination.innerHTML = '';
        let paginationHTML = '';

        if (totalPages <= 1) {
            pagination.style.display = 'none';
            return;
        }

        pagination.style.display = 'flex';
        paginationHTML += `<li class="pagination__page-item"><a href="#" class="pagination__page-link prev" data-page="${this.currentPage - 1}" ${this.currentPage === 1 ? 'disabled' : ''}><i class="fa-regular fa-angle-left"></i></a></li>`;

        for (let i = 1; i <= totalPages; i++) {
            paginationHTML += `<li class="pagination__page-item"><a href="#" class="pagination__page-link ${i === this.currentPage ? 'current' : ''}" data-page="${i}" ${i === this.currentPage ? 'disabled' : ''}>${i}</a></li>`;
        }

        paginationHTML += `<li class="pagination__page-item"><a href="#" class="pagination__page-link next" data-page="${this.currentPage + 1}" ${this.currentPage === totalPages ? 'disabled' : ''}><i class="fa-regular fa-angle-right"></i></a></li>`;
        pagination.innerHTML = `<ul class="pagination__list">${paginationHTML}</ul>`;
    }

}

